import { useMutation, useQueryClient } from 'react-query';
import {
  createBettieFeedPost,
  type CreateBettieFeedPostBody,
  type CreateBettieFeedPostResponse
} from '../../services/bettieFeedService';

type CreateBettieFeedPostVariables = {
  chatRoomId: string;
  body: CreateBettieFeedPostBody;
};

export function useCreateBettieFeedPost() {
  const queryClient = useQueryClient();

  return useMutation<CreateBettieFeedPostResponse, Error, CreateBettieFeedPostVariables>(
    ({ chatRoomId, body }) => createBettieFeedPost(chatRoomId, body),
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries(['bettieFeedPosts', variables.chatRoomId]);
      }
    }
  );
}
